import {Vector3} from "three";

function getPointInBetweenByLen(pointA: Vector3, pointB: Vector3, length: number = 0.5) {
    const dir = pointB.clone().sub(pointA).normalize().multiplyScalar(length);
    return pointA.clone().add(dir);
}

export default getPointInBetweenByLen
